import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { AddCircleOutlineOutlined } from '@material-ui/icons/';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Profile, SidebarNav, UpgradePlan } from './components';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import ViewQuiltOutlinedIcon from '@material-ui/icons/ViewQuiltOutlined'; 

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
       display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, profile, ...rest } = props;

  const classes = useStyles();

  const pages = [
    {
      title: 'PT Schedule',
      href: '/patient-pt-schedule',
      icon: <DateRangeOutlinedIcon />
    },

    {
      title: 'PT Message',
      href: '/patient-pt-message',
      icon: <ForumOutlinedIcon />
    },

    {
      title: 'Logout',
      href: '/pt-login',
      icon: <ExitToAppOutlinedIcon />
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile profile={profile} />
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} />
        {/* <UpgradePlan /> */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

const mapDispatchToProps = {};

const mapStateToProps = state => ({
  profile: state.profile
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Sidebar)
);
